import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {OcDragAndDropDialog, getFileSizeLabelWithUnit} from '@oc/components'
import {useOcAppBarState} from '../../Contexts/OcAppBarStateContext'
import {useViewLoader} from '@oc/shell-core'
import {messages} from '../translations'

const maxSizeInBytes = Math.pow(1024, 2) / 2 // 512KB
const allowedFileExtensions = ['jpeg', 'jpg', 'png']

function _ProfilePictureUploadDialog() {
    const state = useOcAppBarState()
    const {whileLoading} = useViewLoader()

    const onConfirm = React.useCallback(
        async (file: File) => {
            state.toggleFileUploadDialog(false)
            await whileLoading(state.uploadProfilePicture(file))
        },
        [state, whileLoading]
    )

    return (
        <OcDragAndDropDialog
            onConfirmAction={onConfirm}
            uploadDialogOpen={state.isFileUploadDialogOpen}
            allowedFileExtensions={allowedFileExtensions}
            dialogHeaderText={messages.getText(
                'appBar',
                'uploadPicture',
                getFileSizeLabelWithUnit(maxSizeInBytes),
                allowedFileExtensions.join(', ')
            )}
            onCancelAction={() => state.toggleFileUploadDialog(false)}
            maxSizeInBytes={maxSizeInBytes}
        />
    )
}

export const ProfilePictureUploadDialog = observer(_ProfilePictureUploadDialog)
